var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "color-property-item" },
    [
      _c("h6", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" }),
      _vm._v(" "),
      _setup.isHighlightStroke
        ? [
            _vm.highlightStrokeEnabled
              ? [
                  _vm.color
                    ? _c(
                        "div",
                        {
                          staticClass: "color-row border-gray-light rounded",
                          on: { click: _setup.toggleColorPicker },
                        },
                        [
                          _c("span", {
                            staticClass: "color-preview",
                            style: { backgroundColor: _setup.colorHex() },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_setup.colorHex()) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.ColorSelector, {
                    ref: "pickerRef",
                    attrs: {
                      open: _setup.clickOutsideActive,
                      color: _vm.color,
                    },
                    on: {
                      cancel: _setup.toggleColorPicker,
                      "color-selected": _setup.onColorSelected,
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.CInput, {
                    staticClass: "flex-fill",
                    attrs: {
                      value: _vm.highlightStrokeWidth,
                      type: "number",
                      label: "Highlight Outline Width",
                      disabled: _vm.disabled,
                    },
                    on: { input: _setup.onStrokeWidthUpdate },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.CButton, {
              staticClass: "w-100",
              attrs: {
                variant: "secondary",
                text: _vm.highlightStrokeEnabled
                  ? "Remove Highlight Outline"
                  : "Add Highlight Outline",
                icon: _vm.highlightStrokeEnabled
                  ? ["far", "trash"]
                  : ["far", "plus"],
                disabled: _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _setup.emit("toggle-highlight-stroke")
                },
              },
            }),
          ]
        : [
            _vm.color
              ? _c(
                  "div",
                  {
                    staticClass: "color-row border-gray-light rounded",
                    on: { click: _setup.toggleColorPicker },
                  },
                  [
                    _c("span", {
                      staticClass: "color-preview",
                      style: { backgroundColor: _setup.colorHex() },
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_setup.colorHex()) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.ColorSelector, {
              ref: "pickerRef",
              attrs: { open: _setup.clickOutsideActive, color: _vm.color },
              on: {
                cancel: _setup.toggleColorPicker,
                "color-selected": _setup.onColorSelected,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }